import { Button, Grid } from '@material-ui/core';
import { Field, Formik } from 'formik';
import React from 'react';
import { FormikCheckBox } from 'shared/material-ui-formik';
import { IApplicationState } from 'store/state/app-state';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { HttpStatusCode } from 'shared/enums/http-status-code';
import messages from 'shared/constants/messages';
import { IPatientSettingModel } from 'models/patient/index';
import patientSettingService from 'services/patient/patient-setting-service';

interface ISettingFormProps {
    handleDialogClose?: () => void;
    setting?: IPatientSettingModel;
}

const SettingForm: React.FC<ISettingFormProps> = ({ handleDialogClose, setting }) => {
    const userData = useSelector((state: IApplicationState) => state.UserData);

    const initialValue: IPatientSettingModel = {
        settingId: 0,
        patientIdEnc: userData?.patientIdEnc,
        insurance: false,
        pharmacy: false,
        message: false,
        lab: false,
        image: false,
        medication: false,
        diagnosis: false,
        allergy: false,
        vaccine: false,
        vital: false,
        procedures: false,
        documents: false,
        diet: false,
        report: false,
        medicalRecords: false,
    };
    const handleSubmit = async (data) => {
        await patientSettingService
            .addEditPatientSetting(data, userData.userIdEnc)
            .then((response) => {
                if (response?.data?.statusCode === HttpStatusCode.Success) {
                    handleDialogClose();
                    toast.success(messages.PatientSettingSuccess);
                }
            })
            .catch(() => {
                toast.error(messages.SomethingWentWrong);
            });
    };

    return (
        <Formik initialValues={setting || initialValue} onSubmit={handleSubmit} validateOnChange={true}>
            {(props) => {
                const { handleSubmit } = props;
                return (
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-control-block">
                            <h6>
                                By default, the clinical data added in PHR portal will not be shared to EHRM Portal. In
                                order to share clinical data with EHRM, please configure all sections here.
                            </h6>
                            <Grid container spacing={3} className="primary-grid">
                                <Grid item xs={12} sm={4} md={3}>
                                    <div className="form-group">
                                        <Field
                                            label="Insurance"
                                            name="insurance"
                                            id="insurance"
                                            component={FormikCheckBox}
                                            checkedIcon={<span className="unchecked checked" />}
                                            icon={<span className="unchecked" />}
                                        />
                                    </div>
                                </Grid>
                                {/* <Grid item xs={12} sm={4} md={3}>
                                    <div className="form-group">
                                        <Field
                                            label="Pharmacy"
                                            name="pharmacy"
                                            id="pharmacy"
                                            component={FormikCheckBox}
                                            checkedIcon={<span className="unchecked checked" />}
                                            icon={<span className="unchecked" />}
                                        />
                                    </div>
                                </Grid> */}
                                {/* <Grid item xs={12} sm={4} md={3}>
                                    <div className="form-group">
                                        <Field
                                            label="Message"
                                            name="message"
                                            id="message"
                                            component={FormikCheckBox}
                                            checkedIcon={<span className="unchecked checked" />}
                                            icon={<span className="unchecked" />}
                                        />
                                    </div>
                                </Grid> */}
                                <Grid item xs={12} sm={4} md={3}>
                                    <div className="form-group">
                                        <Field
                                            label="Lab Result"
                                            name="lab"
                                            id="lab"
                                            component={FormikCheckBox}
                                            checkedIcon={<span className="unchecked checked" />}
                                            icon={<span className="unchecked" />}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <div className="form-group">
                                        <Field
                                            label="Radiology Result"
                                            name="image"
                                            id="image"
                                            component={FormikCheckBox}
                                            checkedIcon={<span className="unchecked checked" />}
                                            icon={<span className="unchecked" />}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <div className="form-group">
                                        <Field
                                            label="Medication History"
                                            name="medication"
                                            id="medication"
                                            component={FormikCheckBox}
                                            checkedIcon={<span className="unchecked checked" />}
                                            icon={<span className="unchecked" />}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <div className="form-group">
                                        <Field
                                            label="Problem"
                                            name="diagnosis"
                                            id="diagnosis"
                                            component={FormikCheckBox}
                                            checkedIcon={<span className="unchecked checked" />}
                                            icon={<span className="unchecked" />}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <div className="form-group">
                                        <Field
                                            label="Allergy"
                                            name="allergy"
                                            id="allergy"
                                            component={FormikCheckBox}
                                            checkedIcon={<span className="unchecked checked" />}
                                            icon={<span className="unchecked" />}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <div className="form-group">
                                        <Field
                                            label="Immunization"
                                            name="vaccine"
                                            id="vaccine"
                                            component={FormikCheckBox}
                                            checkedIcon={<span className="unchecked checked" />}
                                            icon={<span className="unchecked" />}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <div className="form-group">
                                        <Field
                                            label="Wellness / Vital"
                                            name="vital"
                                            id="vital"
                                            component={FormikCheckBox}
                                            checkedIcon={<span className="unchecked checked" />}
                                            icon={<span className="unchecked" />}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <div className="form-group">
                                        <Field
                                            label="Procedure"
                                            name="procedures"
                                            id="procedures"
                                            component={FormikCheckBox}
                                            checkedIcon={<span className="unchecked checked" />}
                                            icon={<span className="unchecked" />}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <div className="form-group">
                                        <Field
                                            label="Document"
                                            name="documents"
                                            id="documents"
                                            component={FormikCheckBox}
                                            checkedIcon={<span className="unchecked checked" />}
                                            icon={<span className="unchecked" />}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={4} md={3}>
                                    <div className="form-group">
                                        <Field
                                            label="Medical Records"
                                            name="medicalRecords"
                                            id="medicalRecords"
                                            component={FormikCheckBox}
                                            checkedIcon={<span className="unchecked checked" />}
                                            icon={<span className="unchecked" />}
                                        />
                                    </div>
                                </Grid>
                                {/* <Grid item xs={12} sm={4} md={3}>
                                    <div className="form-group">
                                        <Field
                                            label="Report"
                                            name="report"
                                            id="report"
                                            component={FormikCheckBox}
                                            checkedIcon={<span className="unchecked checked" />}
                                            icon={<span className="unchecked" />}
                                        />
                                    </div>
                                </Grid> */}
                            </Grid>
                        </div>
                        <div className="btns-block">
                            <Button variant="contained" className="btn" disableElevation color="primary" type="submit">
                                Save
                            </Button>
                            <Button
                                variant="outlined"
                                className="btn"
                                disableElevation
                                color="primary"
                                onClick={handleDialogClose}
                            >
                                Cancel
                            </Button>
                        </div>
                    </form>
                );
            }}
        </Formik>
    );
};

export default SettingForm;
